<template>
  <Modal>
    <Modal.Title>Rename '{{ item.name }}'</Modal.Title>
    <Modal.Body>
      <Input
        v-model="name"
        size="xl"
        label="Folder name"
        :error="error"
        :disabled="loading"
      />
    </Modal.Body>
    <Modal.Footer>
      <Button variant="stroke" :disabled="loading" @click="close()">
        Cancel
      </Button>
      <Button
        variant="primary"
        :disabled="isSameName"
        :loading="loading"
        @click="handleSave"
      >
        Save
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Input, Button, useModal } from '@dacr/library'
import type { Folder } from '@/shared/graphql/router/graphql'
import { useRenameFolder } from './useRenameFolder'

const { close } = useModal()

const props = defineProps<{
  item: Folder
}>()

const { name, error, loading, isSameName, save } = useRenameFolder(props.item)

const handleSave = async () => {
  if (await save()) close()
}
</script>
